import { Resource as l, API as a } from "@coveo/platform-client";
const i = class i extends l {
  /**
   * Lists all sources of an organization, but returns only basic information about each source.
   */
  listAll() {
    return this.api.get(`${i.baseUrl}/basic/all`);
  }
  /**
   * Returns a paginated list of sources for the specified project.
   *
   * @param {string | undefined} projectId ID of the project for which to retrieve sources.
   * @param {ListSourcesParams} options Options to configure the request.
   * @returns {Promise<PageModel<SourceModel, 'sourceModels'>>} Paginated list of sources for the specified project.
   */
  listSourcesByProjectId(s, e = {}) {
    return this.api.get(
      this.buildPath(`${i.baseUrl}/pages/project`, { ...e, projectId: s })
    );
  }
  /**
   * Returns the salesforce object configuration corresponding to the provided object name for the specified source.
   *
   * @param {string} sourceId ID of the project for which to retrieve sources.
   * @param {string} objectName Name of the object to retrieve the configuration for.
   * @returns {Promise<SalesforceObject>} The salesforce object configuration with sorted fields and relationships.
   */
  async getSalesforceObjectForSource(s, e) {
    const t = await this.api.get(
      this.buildPath(
        `${i.baseUrl}/${s}/configuration/salesforce/objects/${encodeURIComponent(e)}`
      )
    );
    return {
      ...t,
      fields: this.sortObjectFields(t.fields),
      relationships: this.sortObjectRelationships(t.relationships)
    };
  }
  /**
   * Returns the salesforce object configuration corresponding to the provided object relationship name for the specified source.
   *
   * @param {string} sourceId ID of the project for which to retrieve sources.
   * @param {string} objectName Name of the object to retrieve the configuration for.
   * @param {string} relationshipName Name of the relationship to retrieve.
   * @returns {Promise<SalesforceObject>} The salesforce object relationship configuration with sorted fields.
   */
  async getSalesforceObjectRelationshipForSource(s, e, t) {
    const o = await this.api.get(
      this.buildPath(
        `${i.baseUrl}/${s}/configuration/salesforce/objects/${encodeURIComponent(e)}/${encodeURIComponent(t)}`
      )
    );
    return {
      ...o,
      fields: this.sortObjectFields(o.fields)
    };
  }
  /**
   * Returns a paginated list of fields for the specified project.
   *
   * @param {string | undefined} projectId ID of the project for which to retrieve fields
   * @param {ListSourcesFieldsParams} options Options to filter and paginate the results.
   * @returns {Promise<PageModel<SourceFieldModel>>} Paginated list of fields with their associated sources
   */
  listFieldsByProjectId(s, e = {}) {
    return this.api.get(
      this.buildPath(`${i.baseUrl}/page/fields`, {
        ...e,
        projectId: s
      })
    );
  }
  sortObjectFields(s) {
    return s.slice().sort((e, t) => Number(t.indexed) - Number(e.indexed) || e.label.localeCompare(t.label));
  }
  sortObjectRelationships(s) {
    return s.slice().sort((e, t) => e.relationshipName.localeCompare(t.relationshipName)).map((e) => ({
      ...e,
      ...e.fields && { fields: this.sortObjectFields(e.fields) }
    }));
  }
};
i.baseUrl = `/rest/organizations/${a.orgPlaceholder}/sources`;
let r = i;
export {
  r as SourcesInternalResource
};
//# sourceMappingURL=SourcesInternalResource.js.map
